<template>
  <el-row class="flights-footer">
    <div class="count-flights">
      {{ getFlightText(items.length) }}
    </div>
    <el-button
      v-if="canAction('makeFlightsPayments')"
      type="primary"
      :disabled="!items.length"
      @click="unloadingInBank"
    >
      Выгрузить в банк
    </el-button>
    <make-pyments-btn v-if="canAction('makeFlightsPayments')" :items="items" />
    <el-button
      type="primary"
      :loading="loading"
      :disabled="!items.length"
      @click="downloadResponses"
    >
      Скачать заявку
    </el-button>
  </el-row>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import MakePymentsBtn from './MakePymentsBtn'

const documentApi = RepositoryFactory.get('doc')

export default {
  name: 'FlightsFooter',
  components: { MakePymentsBtn },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    downloadResponses() {
      this.loading = true
      let params = this.items.map(item => item.id).join(',')
      const baseURL = process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL_PROD
          : process.env.VUE_APP_API_URL
      const token = localStorage.getItem('auth-token')

      const link = document.createElement('a')

      link.href = `${baseURL}word-builder/logistic-request?bearer-token=${token}&response_ids=${params}`
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => this.loading = false, 500)
    },
    async unloadingInBank() {
      await documentApi
        .unloadingBank(this.items)
        .then(response => {
          const optionDate = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }

          this.forceFileDownload(
            response,
            `выгрузка в банк ${new Date().toLocaleString(
              'ru',
              optionDate,
            )}.txt`,
          )
        })
        .catch(e => console.log('e', e))
    },
    getFlightText(count) {
      let first = 'Выбрано '
      let text = ' рейсов'
      const res10 = count % 10
      const res100 = count % 100

      if (res10 === 1 && res100 !== 11) {
        text = ' рейс'
        first = 'Выбран '
      }
      if ([2, 3, 4].includes(res10) && ![12, 13, 14].includes(res100)) {
        text = ' рейса'
      }

      return first + count + text
    },
  },
}
</script>

<style lang="sass">
.flights-footer
  display: flex
  justify-content: flex-end
  align-items: center
  margin-top: 40px
  .count-flights
    font-size: 18px
    color: #000
    text-transform: uppercase
  button.el-button
    margin-left: 25px
</style>
